import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA8VjMmdO164Gnm5mCc6DfxJWVIEU17wKM",
  authDomain: "seekersbay-b3a21.firebaseapp.com",
  projectId: "seekersbay-b3a21",
  storageBucket: "seekersbay-b3a21.firebasestorage.app",
  messagingSenderId: "180210667887",
  appId: "1:180210667887:web:66a99b129550c6c702189a",
  measurementId: "G-ESPT5G4HB5",
};

export const isFirebaseConfigured = Object.values(firebaseConfig).every(Boolean);

const app = isFirebaseConfigured ? initializeApp(firebaseConfig) : null;

export const auth = app ? getAuth(app) : null;
export const db = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;
export let analytics = null;

if (app && typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export const adminEmails = (process.env.REACT_APP_ADMIN_EMAILS || "")
  .split(",")
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);
